export default function($filter) {
  'ngInject';

  return ({ delivery_date, delivery_end_date }, timeZoneId) => {
    if (delivery_date && delivery_end_date) {
      return `${$filter('PrettyDateTime')(delivery_date, timeZoneId)} - ${$filter('PrettyDateTime')(
        delivery_end_date,
        timeZoneId
      )}`;
    }

    if (delivery_date) {
      return `${$filter('PrettyDate')(delivery_date, timeZoneId)}`;
    }

    return '';
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/DateRangePrettyDateTime.js